import styled from 'styled-components';

import { Button } from '../../../components/Toolkit/Button/Button';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DoneDealMotorEntryPoint = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ theme }) => theme.fontSize.M14};
  margin-top: ${({ theme }) => theme.spacing.M16};
`;

const Container = styled.div``;

const HomePageSearchButton = styled(Button)`
  text-transform: capitalize;
  margin-top: ${({ theme }) => theme.spacing.M16};
`;

export { DoneDealMotorEntryPoint, Wrapper, Container, HomePageSearchButton };
